import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'slug', label: 'Slug (unique)', type: 'text', placeholder: 'e.g. employment, health' },
    { key: 'name', label: 'Name', type: 'text' },
    { key: 'description', label: 'Description', type: 'textarea', rows: 2 },
    { key: 'icon', label: 'Icon (lucide slug)', type: 'text' },
    { key: 'image_url', label: 'Image', type: 'upload-image', prefix: 'sectors' },
    { key: 'order', label: 'Order', type: 'number' },
];

const columns = [
    { key: 'name', label: 'Name', primary: true },
    { key: 'slug', label: 'Slug' },
    { key: 'order', label: 'Order' },
];

const defaultItem = { slug: '', name: '', description: '', icon: 'briefcase', image_url: '', order: 99 };

export default function AdminSectorsPage() {
    return (
        <CrudManager
            resource="sectors"
            title="Our Sectors"
            description="Sectors shown on About Us and used across the site."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['name', 'slug']}
        />
    );
}
